import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cx_foundations-l1_issue-click';

/**
 * Event that tracks an issue being clicked in the topic selection page for self-service
 */
export function trackCxFoundationsL1IssueClick(
  issue_name: string,
  brandretailer_token2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { issue_name, brandretailer_token2 },
  });
}
